import * as colors from "../../constants/colors";
import * as breakpoints from "../../breakpoints";
import * as languages from "../../constants/languages";
import Link from "react-router/lib/Link";
import { english, spanish } from "../../constants/strings";
import { login } from "../../api/auth";
import { css, StyleSheet } from "aphrodite";
import loginStyles from "../../styles/loginStyles";
import Page from "../Page";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { Container, Row, Column } from "../../grid";

const styles = StyleSheet.create({
	input: {
		marginBottom: 16,
		[breakpoints.tabletAndDown]: {
			width: "90%",
		},
	},
	flexRow: {
		marginTop: 0,
		flexDirection: "row",
		alignItems: "baseline",
		[breakpoints.tabletAndDown]: {
			flexDirection: "column",
		},
	},
	noMargins: {},
	textRow: {
		marginTop: 24,
		fontFamily:
			"TrebuchetMS, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma,sans-serif",
		lineHeight: 1.33,
		fontSize: 15,
		color: colors.black4,
	},
	link: {
		fontFamily:
			"TrebuchetMS, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma,sans-serif",
		lineHeight: 1.33,
		fontSize: 15,
		color: colors.darkTeal,
		fontWeight: "bold",
	},
	sectionTitleBanner: {
		paddingTop: 26,
		paddingBottom: 26,
		width: "100vw",
		backgroundColor: colors.pink,
		color: colors.black3,
		fontSize: 30,
		fontFamily: "priori-sans",
		marginTop: 38,
	},
	sectionTitle: {
		maxWidth: 660,
		width: "100%",
		margin: "auto",
		boxSizing: "border-box",
		paddingLeft: 12,
	},
	mainButton: {
		border: `3px solid ${colors.darkTeal2}`,
		borderRadius: 25.5,
		backgroundColor: colors.lightTeal,
		fontSize: 16,
		color: colors.darkGreen,
		lineHeight: 1.06,
		fontWeight: "bold",
		fontFamily: "priori-sans",
		paddingTop: 20,
		paddingBottom: 20,
		width: 200,
		marginLeft: 16,
	},
});

export default class LiveClassCompletePage extends PureComponent {
	static propTypes = {
		language: PropTypes.string.isRequired,
		pathname: PropTypes.string.isRequired,
		params: PropTypes.object.isRequired,
		sessionId: PropTypes.string,
		redirectPath: PropTypes.string,
	};

	constructor(props) {
		super(props);

		this.strings = props.language === languages.es ? spanish : english;

		this.state = { error: null, email: "" };
	}

	_login = e => {
		e.preventDefault();
		login(this.state.email)
			.then(() => {
				const url = this._redirectPath();
				window.location.assign(url);
			})
			.catch(err => {
				if (err.response && err.response.status === 400) {
					this.setState({
						error: this.strings.errors.accountNotFound,
					});
				} else {
					this.setState({
						error: this.strings.errors.loginFailed,
					});
				}
			});
	};

	_currentPath = () => {
		return this.props.redirectPath
			? `${this.props.pathname}?redirectpath=${encodeURIComponent(this.props.redirectPath)}`
			: this.props.pathname;
	};

	_redirectPath = () => {
		return `/post-complete/${this.props.params.class_id}
		${this.props.language ? `?language=${encodeURIComponent(this.props.language)}` : "?language=en"}${
			this.props.sessionId ? `&session=${encodeURIComponent(this.props.sessionId)}` : ""
		}`;
	};

	_setEmail = e => {
		const email = e.target.value;
		this.setState({
			error: null,
			email,
		});
	};

	render() {
		return (
			<Page
				language={this.props.language}
				currentRoute={this._currentPath()}
				loggedIn={false}
			>
				<div>
					<div className={css(styles.sectionTitleBanner)}>
						<div className={css(styles.sectionTitle)}>{this.strings.Log_In}</div>
					</div>
					<Container>
						<Row>
							<Column
								large={8}
								largeOffset={2}
								medium={10}
								mediumOffset={1}
								smallFullScreen={true}
							>
								<form className={css(loginStyles.form)}>
									<div className={css(styles.textRow)}>
										{this.strings.completeClassLoginMessage}
									</div>
									<div className={css(styles.textRow)}>
										{this.strings.EmailAddress}
									</div>
									<div className={css([loginStyles.formItem, styles.flexRow])}>
										<input
											className={css([
												loginStyles.input,
												styles.input,
												this.state.error ? loginStyles.inputError : "",
											])}
											id="email"
											type="text"
											value={this.state.email}
											onChange={this._setEmail}
										/>
										<button
											className={css(styles.mainButton)}
											onClick={this._login}
										>
											{this.strings.LOG_IN}
										</button>
									</div>
									<div className={css(loginStyles.errorMessage)}>
										{this.state.error}
									</div>
								</form>
								<div className={css(styles.textRow)}>
									{this.strings.dontHaveAnAccount}{" "}
									<Link
										className={css(styles.link)}
										to={{
											pathname: "signup",
											query: {
												language: this.props.language,
												redirectpath: `/complete/${
													this.props.params.class_id
												}`,
											},
										}}
									>
										{this.strings.signUp}
									</Link>
								</div>
								<div className={css(styles.textRow)}>
									{this.strings.completeAnonymously}
									<a
										href={this._redirectPath()}
										className={css(styles.link)}
										title={this.strings.completeAnonymously2}
									>
										{this.strings.clickHere}
									</a>
								</div>
							</Column>
						</Row>
					</Container>
				</div>
			</Page>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/LiveClassCompletePage.js